import { render, staticRenderFns } from "./ProjectFolderActionsCreate.vue?vue&type=template&id=2870bd9e&lang=pug&"
import script from "./ProjectFolderActionsCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectFolderActionsCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFolderActionsCreate.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports